module.exports = __webpack_public_path__ + "img/bg_main_program.3e3ba1d.png";